import React from 'react'
import { Container, Accordion, Image } from 'react-bootstrap'

import Project1Card from './projectCards/project1card'
import Project2Card from './projectCards/project2card'
import Project3Card from './projectCards/project3card'
import Project4Card from './projectCards/project4card'
import Project5Card from './projectCards/project5card'
import Project6Card from './projectCards/project6card'

import TWNCover from '../../assets/img/portfolio/twn_cover.svg'
import SafehouseCover from '../../assets/img/portfolio/safehouse_cover.svg'
import CoDesignCover from '../../assets/img/portfolio/codesign_cover.svg'
import VirusAICover from '../../assets/img/portfolio/virus_ai_cover.svg'
import BittorrentCover from '../../assets/img/portfolio/bittorrent_cover.svg'
import WeParkCover from '../../assets/img/portfolio/wepark_cover.svg'

const ProjectHeaderLabel = ({ cover, title }) => (
    <div className='d-flex align-items-center gap-3'>
        <Image src={cover} alt='' width={56} height={41} rounded />
        <span className='fw-bold text-secondary'>{title}</span>
    </div>
)

const Projects = () => {
    return (
        <>
            <section className='bg-primary py-4 mb-1'>
                <Container>
                    <h1 className='text-uppercase text-center text-secondary'>My Projects</h1>
                    <hr className='star-dark mb-0'/>
                    <h4 className='text-center text-secondary'>Explore My Personal Projects</h4>
                </Container>
            </section>
            <Container>
                <Accordion defaultActiveKey='0'>
                    <Accordion.Item eventKey='0'>
                        <Accordion.Header><ProjectHeaderLabel cover={TWNCover} title='True World News' /></Accordion.Header>
                        <Accordion.Body>
                            <Project1Card />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='1'>
                        <Accordion.Header><ProjectHeaderLabel cover={SafehouseCover} title='SafeHouse Digital' /></Accordion.Header>
                        <Accordion.Body>
                            <Project2Card />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='2'>
                        <Accordion.Header><ProjectHeaderLabel cover={CoDesignCover} title='Co-Design' /></Accordion.Header>
                        <Accordion.Body>
                            <Project3Card />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='3'>
                        <Accordion.Header><ProjectHeaderLabel cover={VirusAICover} title='Virus AI' /></Accordion.Header>
                        <Accordion.Body>
                            <Project4Card />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='4'>
                        <Accordion.Header><ProjectHeaderLabel cover={BittorrentCover} title='BitTorrent Clone' /></Accordion.Header>
                        <Accordion.Body>
                            <Project5Card />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='5' className='mb-1'>
                        <Accordion.Header><ProjectHeaderLabel cover={WeParkCover} title='We-Park' /></Accordion.Header>
                        <Accordion.Body>
                            <Project6Card />
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </>
    )
}

export default Projects;
